export function showSnackbar(variant, message, verticalPosition, horizontalPosition, duration){
  return {type: "SHOW_SNACKBAR", payload: {variant: variant, message: message, verticalPosition: verticalPosition, horizontalPosition: horizontalPosition, duration: duration}}
}

export function hideSnackbar(){
  return {type: "HIDE_SNACKBAR"}
}



// WEBPACK FOOTER //
// ./src/js/actions/snackbarActions.js